module.exports = __webpack_public_path__ + "static/media/ic_excluded.dd9d6a72.svg";